import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=c9d028de&scoped=true&"
import script from "./Label.vue?vue&type=script&lang=js&"
export * from "./Label.vue?vue&type=script&lang=js&"
import style0 from "./Label.scss?vue&type=style&index=0&id=c9d028de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d028de",
  null
  
)

export default component.exports